import { LgpdAlert } from "./Lgpd-alert";
import { AgendaAlerts } from "./Agenda-alerts";


export const Alerts = {
  LgpdAlert,
  AgendaAlerts,
}
